module.exports = __webpack_public_path__ + "static/media/sbc_logo.9fb259d7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/sbc_logo.png
// module id = 782
// module chunks = 0